export default __webpack_public_path__ + "static/media/logo-dark.6ff79d81ff4c95671c862c2f8eb2d658.png";